import { render, staticRenderFns } from "./XBpmnDesigner.vue?vue&type=template&id=031d89aa&scoped=true"
import script from "./XBpmnDesigner.vue?vue&type=script&lang=js"
export * from "./XBpmnDesigner.vue?vue&type=script&lang=js"
import style0 from "./XBpmnDesigner.vue?vue&type=style&index=0&id=031d89aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d89aa",
  null
  
)

export default component.exports